import * as React from 'react'

import { Settings2 } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

type IProps = Omit<React.ComponentProps<typeof Button>, 'children'> & {
  iconOnly?: boolean
  /** When true the text label is hidden on small screens (< md). */
  hideLabel?: boolean
}

const ViewOptionsTrigger = React.forwardRef<HTMLButtonElement, IProps>(
  function ViewOptionsTrigger(
    {
      variant = 'outline',
      iconOnly,
      hideLabel,
      size,
      'aria-label': ariaLabel,
      ...props
    },
    ref,
  ) {
    const label = Localization.translator.display
    return (
      <Button
        ref={ref}
        variant={variant}
        size={iconOnly ? (size ?? 'icon') : size}
        // A label that can be hidden still needs an accessible name.
        aria-label={iconOnly || hideLabel ? (ariaLabel ?? label) : ariaLabel}
        {...props}
      >
        <Settings2 aria-hidden="true" />
        {!iconOnly &&
          (hideLabel ? (
            <span className="tw:hidden tw:md:inline">{label}</span>
          ) : (
            label
          ))}
      </Button>
    )
  },
)

export default ViewOptionsTrigger
